import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, AccordionSummary, Paper } from '@mui/material';
import { isEmpty } from 'ramda';
import { FormattedMessage, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { messages } from '../../intl';
import { getCurrentExam } from '../../store/model/selectors';
import DetectedProcesses from './DetectedProcesses';
import DeviceFingerprint from './DeviceFingerprint';
import Peripherals from './Peripherals';

const TechnicalInfo = () => {
	const intl = useIntl();
	const exam = useSelector(getCurrentExam);
	const hw = isEmpty(exam?.hwInfo ?? {}) ? null : exam.hwInfo;

	return (
		<Accordion defaultExpanded={false} elevation={3} sx={{ '&::before': { display: 'none' } }}>
			<AccordionSummary expandIcon={<ExpandMore />} sx={{ px: '20px' }}>
				<h2 style={{ margin: 0, fontWeight: 700, fontSize: '1.2rem' }}>
					{intl.formatMessage(messages.technicalInformation)}
				</h2>
			</AccordionSummary>
			<AccordionDetails sx={{ px: '20px', pb: '20px', pt: 0 }}>
				{hw && (
					<>
						{hw.os?.platform && (
							<Paper elevation={3} style={{ padding: '20px' }}>
								<FormattedMessage {...messages.operatingSystem} />
								{`: ${hw.os.platform === 'darwin' ? 'macOS' : hw.os.platform} ${hw.os.release} (${
									hw.cpu.arch
								}), RAM: ${Math.floor(hw.ram.totalmem / 1024 ** 3)} GB,
						CPU: ${hw.cpu.model} - ${hw.cpu.cores} core(s)`}
							</Paper>
						)}
						{(hw.webcamDevice?.length > 0 || hw.microphoneDevice?.length > 0) && (
							<Paper elevation={3} style={{ padding: '20px', marginTop: '20px' }}>
								<FormattedMessage {...messages.webcamDevice} />
								{`: ${hw.webcamDevice}`}
								<br />
								<FormattedMessage {...messages.microphoneDevice} />
								{`: ${hw.microphoneDevice}`}
							</Paper>
						)}
						<Peripherals peripherals={hw.peripherals} />
					</>
				)}
				<div style={{ marginTop: '20px' }}>
					<DeviceFingerprint />
				</div>
				{exam?.detectedProcesses?.length > 0 && (
					<div style={{ marginTop: '20px' }}>
						<DetectedProcesses />
					</div>
				)}
			</AccordionDetails>
		</Accordion>
	);
};

export default TechnicalInfo;
